import { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'

import copyJson from '../demo/fixtures/copy.json'
import { useDemoStore } from '../demo/store'
import { Button, Icon, Modal, Toast, ToastHost, type IconName } from '../ui'
import styles from './Sidebar.module.css'

interface NavItem {
  key: string
  label: string
  icon: IconName
  to?: string
  disabled?: boolean
  position?: 'bottom'
}

interface CopyFixture {
  nav: NavItem[]
  resetLabel: string
  resetConfirm: { title: string; text: string; ok: string; cancel: string }
}

const copy = copyJson as unknown as CopyFixture

function DisabledItem({ item }: { item: NavItem }) {
  return (
    <div className={`${styles.item} ${styles.disabled}`} title="演示站只做四屏，此项不可用" aria-disabled="true">
      <Icon name={item.icon} size={21} />
      <span>{item.label}</span>
    </div>
  )
}

function NavigationItem({ item }: { item: NavItem }) {
  if (item.disabled || !item.to) return <DisabledItem item={item} />
  return (
    <NavLink to={item.to} className={({ isActive }) => `${styles.item} ${isActive ? styles.active : ''}`}>
      <Icon name={item.icon} size={21} />
      <span>{item.label}</span>
    </NavLink>
  )
}

export function Sidebar() {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [showToast, setShowToast] = useState(false)
  const reset = useDemoStore((state) => state.reset)
  const navigate = useNavigate()
  const top = copy.nav.filter((item) => item.position !== 'bottom')
  const bottom = copy.nav.filter((item) => item.position === 'bottom')

  const confirmReset = () => {
    reset()
    setConfirmOpen(false)
    setShowToast(true)
    void navigate('/monitor')
  }

  return (
    <>
      <aside className={styles.sidebar} data-scope="app-sidebar">
        <nav className={styles.nav} aria-label="主导航">{top.map((item) => <NavigationItem key={item.key} item={item} />)}</nav>
        <div className={styles.spacer} />
        <button type="button" className={styles.reset} onClick={() => setConfirmOpen(true)}>{copy.resetLabel}</button>
        <nav className={styles.nav} aria-label="辅助导航">{bottom.map((item) => <NavigationItem key={item.key} item={item} />)}</nav>
      </aside>
      <Modal
        open={confirmOpen}
        title={copy.resetConfirm.title}
        hint={copy.resetConfirm.text}
        onClose={() => setConfirmOpen(false)}
        footer={<><Button variant="ghost" onClick={() => setConfirmOpen(false)}>{copy.resetConfirm.cancel}</Button><Button onClick={confirmReset}>{copy.resetConfirm.ok}</Button></>}
      />
      {showToast ? <ToastHost><Toast onDismiss={() => setShowToast(false)}>演示数据已重置</Toast></ToastHost> : null}
    </>
  )
}
